import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { Adjustment } from './Adjustment/Adjustment'

export const adjustmentContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.adjustment.adjustment).to(Adjustment)
})
